import { GET_DETECTOR, LIST_DETECTOR } from "../actions/types";

const initialState = {
  detector: null,
  detectors: {
    count: 0,
    rows: [],
  },
  submitError: null,
};

const detectors = (state = initialState, action) => {
  switch (action.type) {
    case GET_DETECTOR:
      return {
        ...state,
        detector: action.payload,
        detectors: initialState.detectors,
      };
    case LIST_DETECTOR:
      return {
        ...state,
        detectors: action.payload,
        detector: initialState.detector,
      };
    default:
      return state;
  }
};

export default detectors;
